
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/community/list",
      function () {
        return require("private-next-pages/content/community/list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/community/list"])
      });
    }
  